import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useInstance from './useInstance';

const useHasTenant = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getTenantById } = useInstance();

  useEffect(() => {
    const handleHashChange = () => {
      window.location.reload();
    };

    window.addEventListener('hashchange', handleHashChange);

    const hash = location.hash;
    const cid = +hash.replace('#', '').replace('cid=', '');
    const tenant = getTenantById(cid);

    if (!Boolean(tenant) && location.hash.includes('cid=')) {
      window.history.replaceState(null, '', location.pathname);
    }

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location, getTenantById]);
};

export default useHasTenant;
